import React from 'react';
import { isBrowser } from '@cp/utils/browser';
import { deleteAllCookies } from '../utils/cookie';
const CLIENT_STORAGE_DATA_VALID_AFTER = 1645461147764; // Unix timestamp

const storage: { setItem(key: string, value: unknown): void; getItem(key: string): string | null } =
  isBrowser && typeof window.localStorage !== 'undefined'
    ? window.localStorage
    : {
        setItem() {
          return;
        },
        getItem: () => null,
      };

export const useCookieStorageCleaner = () => {
  React.useEffect(() => {
    const lastCleanupTs = storage.getItem('lastCleanupTs');
    if (!lastCleanupTs) {
      storage.setItem('lastCleanupTs', Date.now());
      return;
    }

    if (Number(lastCleanupTs) < CLIENT_STORAGE_DATA_VALID_AFTER) {
      deleteAllCookies();
      storage.setItem('lastCleanupTs', Date.now());
    }
  }, []);
};
